import { render } from "./ProjectLayout.vue?vue&type=template&id=cbba1f4c"
import script from "./ProjectLayout.vue?vue&type=script&lang=js"
export * from "./ProjectLayout.vue?vue&type=script&lang=js"

import "./ProjectLayout.vue?vue&type=style&index=0&id=cbba1f4c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__